import React from "react";
import {Link} from "react-router-dom";

const IosLink = () => {
    return (
        <Link to="/">
            <img alt="link" className="block-link"
                 src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065562/FunRecycle/ios-link-min_j4qrjh.svg"
            />
        </Link>
    )
}

const AndroidLink = () => {
    return (
        <Link to="/">
            <img alt="link" className="block-link"
                 src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065562/FunRecycle/android-link-min_r7hjnv.svg"
            />
        </Link>
    )
}

export const LinkButtons = () => {
    return (
        <div className="block-links">
            <IosLink/>
            <AndroidLink/>
        </div>
    )
};